import locationAddressModelValidator from 'forms/shared/validators/models/location/models/address';
import { DEFAULT_LATEST, TODAY } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth, getSafeDateTime } from 'helpers/date';
import { SubstanceAlcoholSupplementalCounselingItemModel } from '../types';

const substanceAlcoholSupplementalCounselingItemValidator: ValidateJSModel<SubstanceAlcoholSupplementalCounselingItemModel> = {
  TreatmentProviderName: { presence: true, hasValue: true },
  TreatmentProviderAddress: {
    presence: true,
    location: { validator: locationAddressModelValidator },
  },
  CounselingDates: (value, attributes, attributeName, options) => {
    const { applicantBirthdate } = options;

    const toDate = getSafeDateTime(value?.to);
    const requiredDate = setToStartOfMonth(getSafeDateTime(TODAY.minus({ years: 5 })));
    const beyondRequired = (toDate.valid && requiredDate?.valid) ? (toDate?.datetime < requiredDate?.datetime) : false;

    return {
      presence: true,
      daterange: {
        requireYear: false,
        earliest: beyondRequired ? requiredDate?.datetime : applicantBirthdate,
        latest: DEFAULT_LATEST,
        tooEarly: beyondRequired ? 'error.beforeDuration' : 'error.applicantMin',
      },
    };
  },
  ConsultationComment: {},
};

export default substanceAlcoholSupplementalCounselingItemValidator;
